import { EsfPcFangyuanFooter } from '@ajk/fe-vue-ui';
import { isH5Url, loadScript, parseQueryString } from '../../utils/common';
import { getAppEnv } from '../../utils/env';
import DATA from '../captcha-geetest/index.json';
import CaptchaButton from '~/components/captcha/button/index.vue';
import Nav from '~/components/captcha/nav/index.vue';
import mixins from '~/components/captcha/mixins';

const URL = DATA.URL;
export default {
    mixins: [mixins],
    components: {
        CaptchaButton,
        Nav,
        Footer: EsfPcFangyuanFooter.component
    },
    data() {
        return {
            showCaptcha: false,
            isPC: false,
            isApp: false,
            isWapp: false
        };
    },
    head() {
        return {
            title: '安全验证'
        };
    },
    mounted() {
        // 加载网易验证码
        const url = '//pages.anjukestatic.com/usersite/site/js/captcha/captcha.js';
        loadScript(url, 'head');
        this.plat = this.judgeFrom();
        this.isApp = this.plat === 'app';
        this.isPC = this.plat === 'pc';
        this.isWapp = this.plat === 'wapp';
    },
    methods: {
        initCaptcha(val) {
            this.showCaptcha = val;
            const params = {
                captcha_type: 'wangyi',
                platform: this.plat
            };
            this.$fetch({
                url: URL.register,
                params
            })
                .then(data => {
                    if (data && data.captcha_params) {
                        const captchaWyid = data.captcha_params.captcha_id;
                        // eslint-disable-next-line no-undef
                        initNECaptchaWithFallback(
                            {
                                captchaId: captchaWyid,
                                element: '#captcha',
                                mode: 'float',
                                width: '320px',
                                protocol: 'https',
                                onReady: () => {
                                    console.log('onready');
                                },
                                onVerify: (err, data) => {
                                    if (!err) {
                                        // 验证成功后，调用close方法关闭弹框（enableClose为true时调用）
                                        this.verifyCaptcha(data.validate);
                                    }
                                }
                            },
                            instance => {
                                // 初始化成功
                                console.log('success');
                            },
                            err => {
                                console.log(err, 'err');
                            }
                        );
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        },
        verifyCaptcha(val) {
            const urlObj = parseQueryString(location.href);
            const urlHistory = decodeURIComponent(urlObj.history);
            const plat = this.plat;

            let Action = null;

            if (!window.browser) {
                window.browser = {
                    versions: (function() {
                        const u = navigator.userAgent;
                        const uLower = u.toLowerCase();
                        return {
                            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                            android: u.includes('Android') || u.includes('Linux'),
                            iPhone: u.includes('iPhone'),
                            iPad: u.includes('iPad'),
                            isWx: u.includes('MicroMessenger'),
                            isMiniProgram: uLower.includes('miniprogram'),
                            isWb: u.includes('Weibo')
                        };
                    })()
                };
            }

            function getQueryVariable(variable) {
                const query = window.location.search.substring(1);
                const vars = query.split('&');
                for (let i = 0; i < vars.length; i++) {
                    const pair = vars[i].split('=');
                    // eslint-disable-next-line eqeqeq
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
                return false;
            }

            const appEnv = getAppEnv(window.navigator.userAgent, window.location.host);

            // 判断环境
            function getEnv() {
                return {
                    isAjk: appEnv.platform === 'anjuke',
                    isWuba: appEnv.platform === 'wuba',
                    // 增加小程序环境判断
                    isWxMiniProgram: appEnv.app === 'weapp',
                    // eslint-disable-next-line unicorn/prefer-starts-ends-with
                    isSwanMiniProgram: appEnv.app === 'swan' || /^webswan-/.test(window.name),
                    isQuickApp: appEnv.isQuickApp,
                    isAliMiniProgram: appEnv.app === 'alipay',
                    isTtMiniProgram: appEnv.app === 'tt',
                    isKsMiniProgram: appEnv.app === 'ks'
                };
            }

            function loadActions() {
                if (appEnv.platform === 'wuba') {
                    Action = getBrige('wuba');
                } else {
                    Action = getBrige('anjuke');
                }
            }

            function getBrige(env) {
                // 兼容老版本bridge
                function hybird(callback) {
                    if (window.WebViewJavascriptBridge) {
                        return callback(window.WebViewJavascriptBridge);
                    }
                    if (window.WVJBCallbacks) {
                        return window.WVJBCallbacks.push(callback);
                    }
                    window.WVJBCallbacks = [callback];
                    const WVJBIframe = document.createElement('iframe');
                    WVJBIframe.style.display = 'none';
                    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
                    document.documentElement.appendChild(WVJBIframe);
                    setTimeout(function() {
                        document.documentElement.removeChild(WVJBIframe);
                    }, 0);
                }

                function do58Action(key, cmd) {
                    if (window.WBAPP && window.WBAPP.action && window.WBAPP.action[key]) {
                        window.WBAPP.action[key](cmd);
                    }
                }

                // 桥的构造函数与对应环境方法
                function Bridge(env) {
                    this.env = env || '';
                }
                Bridge.prototype = {
                    constructor: Bridge,
                    goBack() {
                        console.log(this.env + '未实现该方法');
                    },
                    toggleGesture() {
                        console.log(this.env + '未实现该方法');
                    },
                    controlBack() {
                        console.log(this.env + '未实现该方法');
                    }
                };

                function BridgeWuba(env) {
                    Bridge.call(this, env);
                }
                BridgeWuba.prototype = new Bridge();
                BridgeWuba.prototype.constructor = BridgeWuba;
                BridgeWuba.prototype.goBack = function(params) {
                    params = params || false;
                    do58Action('goback', params);
                };
                BridgeWuba.prototype.toggleGesture = function(cmd) {
                    do58Action('toggleGesture', cmd);
                };
                BridgeWuba.prototype.controlBack = function(params, callback) {
                    do58Action('deviceEvent', function() {
                        if (callback) callback();
                        return true;
                    });
                };

                function BridgeAnjuke(env) {
                    Bridge.call(this, env);
                    this.isIos = window.browser.ios;
                    this.isAndroid = window.browser.android;
                }
                BridgeAnjuke.prototype = new Bridge();
                BridgeAnjuke.prototype.constructor = BridgeAnjuke;
                BridgeAnjuke.prototype.goBack = function(params = false) {
                    params = params || false;
                    const length = history.length;
                    if (length > 1 && !params) {
                        // 如果webview有其它路径
                        if (window.browser.versions.ios) {
                            do58Action('goback');
                        } else {
                            history.back();
                        }
                    } else if (window.browser.versions.android) {
                        do58Action('goback', true);
                        location.href = 'call-app-method://closePage';
                    } else {
                        do58Action('goback', true);
                    }

                    if (length > 1 && !params) {
                        // 如果webview有其它路径
                        history.back();
                    } else {
                        hybird(function(bridge) {
                            bridge.callHandler('closeAnjukeWebViewPage', null, null);
                        });
                    }
                };
                BridgeAnjuke.prototype.controlBack = function(params, callback) {
                    window.checkAjkAppUseGoBack = callback;
                };
                BridgeAnjuke.prototype.toggleGesture = function(cmd) {
                    do58Action('toggleGesture', cmd);
                };

                if (env === 'wuba') {
                    return new BridgeWuba(env);
                }
                if (env === 'anjuke') {
                    return new BridgeAnjuke(env);
                }

                return null;
            }
            // 加载代码
            loadActions();
            // 设置返回手势禁用
            Action.toggleGesture('off');
            // 设置返回按钮禁用
            Action.controlBack(null, function() {
                // tips.css('visibility', 'visible');
                // setTimeout(function() {
                //     tips.css('visibility', 'hidden');
                // }, 3000);
                return true;
            });

            // 通用小程序入参
            const miniProgramLastPage = decodeURIComponent(getQueryVariable('last_page') || '');
            if (urlObj) {
                const env = getEnv();
                const varifyParams = {
                    captcha_type: 'wangyi',
                    namespace: urlObj.namespace,
                    serialID: urlObj.serialID,
                    history: urlHistory,
                    validate: val
                };
                this.$fetch({
                    url: URL.verify,
                    params: varifyParams
                })
                    .then(data => {
                        if (data.verify) {
                            // 跳转
                            setTimeout(function() {
                                if (env.isWxMiniProgram) {
                                    // eslint-disable-next-line no-undef
                                    wx.miniProgram.redirectTo({
                                        url: miniProgramLastPage
                                    });
                                    return;
                                }
                                if (env.isQuickApp) {
                                    // eslint-disable-next-line no-undef
                                    system.go(miniProgramLastPage);
                                    return;
                                }
                                if (env.isSwanMiniProgram) {
                                    // eslint-disable-next-line no-undef
                                    swan.webView.redirectTo({
                                        url: miniProgramLastPage
                                    });
                                    return;
                                }
                                if (env.isAliMiniProgram) {
                                    // eslint-disable-next-line no-undef
                                    my.redirectTo({
                                        url: miniProgramLastPage
                                    });
                                    return;
                                }
                                if (env.isTtMiniProgram) {
                                    // eslint-disable-next-line no-undef
                                    tt.miniProgram.redirectTo({
                                        url: miniProgramLastPage
                                    });
                                    return;
                                }
                                if (env.isKsMiniProgram) {
                                    // eslint-disable-next-line no-undef
                                    ks.redirectTo({
                                        url: miniProgramLastPage
                                    });
                                    return;
                                }
                                if (plat === 'tw' || plat === 'pc') {
                                    if (data.history) {
                                        const history = decodeURIComponent(data.history);
                                        location.href = history;
                                        return;
                                    }
                                    // 兼容小程序转H5页面
                                    if (isH5Url(miniProgramLastPage)) {
                                        location.href = miniProgramLastPage;
                                        return;
                                    }
                                }
                                Action.goBack();
                            }, 200);
                        } else {
                            this.$toast('验证失败！');
                        }
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }
        }
    }
};
